document.addEventListener('DOMContentLoaded', function() {
  // Function to apply Tailwind CSS classes
  function addTailwindClasses() {
      // Form wrappers
      document.querySelectorAll('.gform_wrapper').forEach(function(wrapper) {
          wrapper.classList.add('max-w-3xl', 'p-10', '/bg-sedbergh-brown', 'bg-senior-light-brown', 'relative', '/noise-background', '/noise-invert');
      });

      // gfields
      document.querySelectorAll('.gfield').forEach(function(field) {
          field.classList.add('mb-4');
      });

      // Form headings and descriptions
      document.querySelectorAll('.gform_heading').forEach(function(heading) {
          heading.classList.add('text-white', 'text-xl', 'pb-8', 'font-playfair');
      });

      document.querySelectorAll('.gform_description').forEach(function(description) {
          description.classList.add('text-white', 'text-base', 'pb-4', 'font-azo');
      });
    //   HTML content
    document.querySelectorAll('.gfield--type-html', 'gfield--input-type-html').forEach(function(input) {
        input.classList.add('text-white', 'font-azo', 'text-sm', 'mb-2');
    });

      // Inputs and Textareas
      document.querySelectorAll('.gform_wrapper input[type="text"], .gform_wrapper input[type="number"], .gform_wrapper input[type="email"], .gform_wrapper input[type="tel"], .gform_wrapper textarea').forEach(function(input) {
          input.classList.add('text-black', 'shadow', 'appearance-none', 'border', 'rounded-lg', 'w-full', 'text-base', 'py-3', 'px-5', 'mb-4', 'leading-tight', 'focus:outline-none', 'focus:shadow-outline');
      });

      // Labels
      document.querySelectorAll('.gform_wrapper label').forEach(function(label) {
          label.classList.add('block', 'text-white', 'font-azo', 'text-sm', 'mb-2');
      });

      document.querySelectorAll('.gform_wrapper label .gfield_required').forEach(function(labelAstrx) {
          labelAstrx.classList.add('text-sedbergh-gold');
      });

      // Sub labels for radio buttons, checkboxes, etc.
      document.querySelectorAll('.gform_wrapper .ginput_container .gfield_label').forEach(function(subLabel) {
          subLabel.classList.add('hidden');
      });

      document.querySelectorAll('.gform_wrapper .gform-field-label--type-sub').forEach(function(subLabel) {
          subLabel.classList.add('hidden');
      });

      // Descriptions
      document.querySelectorAll('.gform_wrapper .gfield_description').forEach(function(description) {
          description.classList.add('text-white', 'text-xs', 'italic', '-mt-1');
      });

      // Submit button
      // document.querySelector('.gform_wrapper button[type=submit], .gform_wrapper input[type=submit], .gform_button')?.classList.add('bg-sedbergh-gold', 'text-white', 'font-azo', 'uppercase', 'pt-3', 'pb-2', 'px-12', 'rounded-lg', 'focus:outline-none', 'focus:shadow-outline', 'cursor-pointer');
      document.querySelectorAll('.gform_wrapper button[type="submit"], .gform_wrapper button[type="button"], .gform_next_button, .gform_wrapper input[type=submit], .gform_button').forEach(function(submitButton) {
        submitButton.classList.add('bg-sedbergh-gold', 'text-white', 'font-azo', 'uppercase', 'pt-3', 'pb-2', 'px-12', 'rounded-lg', 'focus:outline-none', 'focus:shadow-outline', 'cursor-pointer');
      });
      // File upload inputs
      document.querySelectorAll('.gform_wrapper input[type=file]').forEach(function(fileInput) {
          fileInput.classList.add('block', 'bg-gray-50', 'w-full', 'text-sm', 'text-white', 'px-4', 'py-6', 'rounded-md', 'border-dotted', 'border-gray-500', 'border', 'file:mr-4', 'file:py-2', 'file:px-4', 'file:border-0', 'file:shadow-md', 'file:drop-shadow', 'file:text-sm', 'file:font-sem', 'file:bg-blue-50', 'file:text-blue-700', 'hover:file:bg-blue-100');
      });

      // Dropdowns
      document.querySelectorAll('.gform_wrapper select').forEach(function(dropdown) {
          dropdown.classList.add('bg-select-chevron', 'border', 'border-gray-300', 'rounded-lg', 'text-gray-900', 'text-sm', 'mb-4', 'py-3', '!px-5', 'focus:ring-gray-300', 'focus:border-gray-300', 'block', 'w-full', 'focus:outline-none', 'focus-visible:ring-1', 'focus-visible:ring-gray-300');
      });

      // Radio buttons and Checkboxes
      document.querySelectorAll('.gform_wrapper .gfield_radio, .gform_wrapper .gfield_checkbox').forEach(function(choice) {
          choice.classList.add('py-2');
      });

      document.querySelectorAll('.gform_wrapper .gfield_radio .gchoice , .gform_wrapper .gfield_checkbox .gchoice ').forEach(function(choice) {
          choice.classList.add('flex');
      });

      // Radio buttons and Checkboxes specifics
      document.querySelectorAll('.gform_wrapper .gfield_radio input[type=radio], .gform_wrapper .gfield_checkbox input[type=checkbox]').forEach(function(choice) {
          choice.classList.add('mr-2', 'text-blue-500', 'mb-2');
      });

      // Dialogues
      document.querySelectorAll('.gform_wrapper .gform_submission_error, .gform_wrapper .validation_message').forEach(function(error) {
          error.classList.add('block', 'mb-2', 'text-red-500', 'p-2', 'text-sm', '-mt-3');
      });

      // Consent
      document.querySelectorAll('.ginput_container_consent').forEach(function(consent) {
          consent.classList.add('flex', 'items-center', 'gap-4');
      });

      document.querySelectorAll('.gfield_consent_label').forEach(function(consentLabel) {
          consentLabel.classList.add('mt-2');
      });

      document.querySelectorAll('.gfield_consent_label a').forEach(function(consentLabelLink) {
          consentLabelLink.classList.add('/text-sedbergh-gold');
      });

      // Hide honeypot field
      document.querySelectorAll('.gfield--type-honeypot').forEach(function(honeypot) {
          honeypot.classList.add('hidden');
      });

      // Hide form breaks
      document.querySelectorAll('.ginput_container  br').forEach(function(formBreak) {
          formBreak.classList.add('hidden');
      });

      // Remove <p> tags from around name_first and name_last spans
      document.querySelectorAll('.gfield .name_first, .gfield .name_last').forEach(function(nameField) {
          var parentP = nameField.closest('p');
          if (parentP) {
              parentP.parentNode.insertBefore(nameField, parentP);
              parentP.remove();
          }
      });
  }

  // Initially apply Tailwind classes
  addTailwindClasses();

  // Observer to reapply classes upon form updates
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          addTailwindClasses();
      });
  });

  // Observe each form wrapper for changes in the DOM
  document.querySelectorAll('.gform_wrapper').forEach(function(form) {
      observer.observe(form, {
          childList: true,
          subtree: true
      });
  });
});


  // Placeholders
  document.addEventListener('DOMContentLoaded', function() {
    // Get all the input and textarea elements
    var inputs = document.querySelectorAll('.gform_wrapper input[type=text], .gform_wrapper input:not([type=submit]), .gform_wrapper textarea');
  
    inputs.forEach(function(input) {
      // Get the id of the input field
      var inputId = input.id;
  
      // If there's an id, find the label that's 'for' this input
      if (inputId) {
        var label = document.querySelector('label[for="' + inputId + '"]');
        // If a label was found and the input doesn't already have a placeholder, set the label text as placeholder
        if (label && !input.placeholder) {
          input.placeholder = label.textContent.trim();
          // Optionally, hide the label for visual purposes but keep it for screen readers
          // label.classList.add('screen-reader-text');
        }
      } else {
        // For inputs without an id, we attempt to get the closest .gfield_label
        var parent = input.closest('.gfield');
        if (parent) {
          var label = parent.querySelector('.gfield_label');
          if (label && !input.placeholder) {
            input.placeholder = label.textContent.trim();
            // label.classList.add('screen-reader-text');
          }
        }
      }
    });
  });
  

  // select placeholder
  document.addEventListener('DOMContentLoaded', function() {
    // Get the country select element
    var countryDropdown = document.querySelector('.gform_wrapper .ginput_address_country');
  
    // Only proceed if the country select element exists
    if (countryDropdown) {
      // Create a new option element
      var placeholderOption = document.createElement('option');
      
      // Set the placeholder text
      placeholderOption.textContent = 'Select a country'; // Your placeholder text
      placeholderOption.value = ''; // No value as it's a placeholder
  
      // Add necessary attributes to act as a placeholder
      placeholderOption.setAttribute('disabled', 'disabled');
      placeholderOption.setAttribute('selected', 'selected');
      
      // Ensure the placeholder option is not selectable after a selection is made
      placeholderOption.setAttribute('hidden', 'hidden');
  
      // Insert the placeholder option at the start of the select element
      countryDropdown.insertBefore(placeholderOption, countryDropdown.firstChild);
  
      // To ensure the placeholder is not used as a value, we listen for a change event
      countryDropdown.addEventListener('change', function() {
        placeholderOption.removeAttribute('selected');
      });
    }
  });
  

  // Set UK as default country
  // document.addEventListener('DOMContentLoaded', function() {
  //   var countryDropdown = document.querySelector('.ginput_address_country');
  
  //   if (countryDropdown) {
  //     // Set United Kingdom as the default selected country
  //     Array.from(countryDropdown.options).forEach(function(option) {
  //       if (option.value === 'United Kingdom') {
  //         option.selected = true;
  //       }
  //     });
  //   }
  // });
  